'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createChainablePropType = require('./createChainablePropType');

var _createChainablePropType2 = _interopRequireDefault(_createChainablePropType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var componentPropType = function componentPropType(props, propName, componentName) {
  var value = props[propName];
  if (value == null || typeof value === 'string' || typeof value === 'function' || typeof value.render === 'function') return null;
  return new Error(componentName + ': Invalid ' + propName + ' value. Expected a component.');
};

exports.default = (0, _createChainablePropType2.default)(componentPropType, 'component');
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1755/js/utils/propTypes/component.js
// module id = 463
// module chunks = 2 3